import React, { createContext, useContext, useMemo, useState } from 'react';
import PropTypes from 'prop-types';

import { useMapPopUps } from '../hooks/useMapPopUps';
import { useGeneralContext } from './GeneralContext';
import { useIsTabletOrMobile } from '../hooks/useIsTabletOrMobile';

const MapPopUpsContext = createContext({ state: {}, actions: {} });

const MapPopUpsProvider = ({ children }) => {
  const { user, isMapPage } = useGeneralContext();
  const isTabletOrMobile = useIsTabletOrMobile();
  const [updating, setUpdating] = useState(false);
  const [follow, setFollow] = useState(null);
  const { isLoading, data, refetch } = useMapPopUps(
    user?.email,
    isTabletOrMobile,
    isMapPage,
  );
  const [showsMapPopUp, setShowsMapPopUp] = useState(!isTabletOrMobile);
  const mapPopUpsIdList = useMemo(() => data?.list || [], [data]);
  const tableId = useMemo(() => data?.id, [data]);

  const values = useMemo(
    () => ({
      isLoading,
      mapPopUpsIdList,
      tableId,
      refetch,
      showsMapPopUp,
      setShowsMapPopUp,
      updating,
      setUpdating,
      follow,
      setFollow,
    }),
    [
      isLoading,
      mapPopUpsIdList,
      tableId,
      refetch,
      showsMapPopUp,
      updating,
      follow,
    ],
  );

  return (
    <MapPopUpsContext.Provider value={values}>
      {children}
    </MapPopUpsContext.Provider>
  );
};

export const useMapPopUpsContext = () => {
  return useContext(MapPopUpsContext);
};

MapPopUpsProvider.defaultProps = {
  children: null,
};

MapPopUpsProvider.propTypes = {
  children: PropTypes.element,
};

export default MapPopUpsProvider;
